import React from "react";

import { Grid } from "@mui/material";
import { Column } from "Components/AppGrid/shipeezi-new-grid";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import { Despatch } from "../../../../../../../models/despatch";
import { formatDateWithoutTimeZone } from "../../../../../../../util/Format";
import { DespatchViewGridData } from "../GridData";

type DespatchViewTruckProps = {
  despatch: Despatch | null;
};
export const DespatchViewTruck: React.FC<DespatchViewTruckProps> = (props) => {
  const { despatch } = props;

  const { t: translate } = useTranslation();

  const renderDeliveryHour = (value?: string) => {
    if (!value) return "";

    const date = new Date();
    const [hour, minutes] = value.split(":");

    date.setHours(Number(hour));
    date.setMinutes(Number(minutes));

    return format(date, "HH:mm a");
  };

  const columns: Column[] = [
    {
      name: "fleetType",
      title: translate("truckType"),
    },
    {
      name: "bookingNumber",
      title: translate("truckBookingNumber"),
    },
    {
      name: "palletsPerFleet",
      title: translate("palletsPerTruck"),
    },
    {
      name: "deliveryDate",
      title: translate("deliveryDate"),
      formatText: (value?: string) => formatDateWithoutTimeZone(value),
    },
    {
      name: "deliveryWindowOpen",
      title: translate("deliveryWindowOpen"),
      formatText: renderDeliveryHour,
    },
    {
      name: "deliveryWindowClose",
      title: translate("deliveryWindowClose"),
      formatText: renderDeliveryHour,
    },
  ];

  return (
    <Grid container direction="column" wrap="nowrap" data-cy="view-trucks-container">
      <DespatchViewGridData data={despatch?.fleets} columns={columns} />
    </Grid>
  );
};
